import axios from "axios";
import React, { useState, useEffect, Component } from 'react'
import { Button, Col, Container, ListGroup, Row, Badge, Modal, Form, FormGroup, FormLabel , Card, ProgressBar, Table} from "react-bootstrap";
import { Navigate} from 'react-router-dom';
import CurrencyInput,{ formatValue } from 'react-currency-input-field';
import {connect} from 'react-redux';
import {getCategories, setCategory} from '../context/actions/index';
import { 
  FaPlus, 
  FaEdit, 
  FaTrash, 
  FaChartPie, 
  FaMoneyBillWave,
  FaShoppingCart,
  FaHome,
  FaUtensils,
  FaCar
} from 'react-icons/fa';
import CreateCategoryForm from "./CreateCategoryForm"
//import {CreateAssetForm} from './createAsset'

class Category extends Component{
    handleClose = () => this.setState({data:'',show:false, update:false});
    handleShow = () => this.setState({show:true});
    //navigate = useNavigate()
    constructor(props){
        super(props);
		this.state ={
			show: false,
            data:'',
            update:false
		}
    }
    componentDidMount(){
        /*
        if(typeof localStorage.bookId!=="undefined"){
            var bookId = JSON.parse(localStorage.bookId);
        }
        */
        //this.props.getCategories(bookId)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }

    // Menghitung total anggaran
    getTotalAllocatedIncome = () => {
        let expense = this.props.categories.filter(category=>category.type=="1")
        return expense.reduce((total, category) => total + parseInt(category.budget), 0);
    };
    getTotalAllocatedExpenses = () => {
        let expense = this.props.categories.filter(category=>category.type=="2")
        return expense.reduce((total, category) => total + parseInt(category.budget), 0);
    };

    // Menghitung total pengeluaran
    
    getTotalExpenses = () => {
        let expense = this.props.transactions.filter(transaction=>transaction.type=="2")
        return Math.abs(expense.reduce((total, transaction) => total + parseInt(transaction.amount), 0));
    };

    getTotalIncome = () => {
        let expense = this.props.transactions.filter(transaction=>transaction.type=="1")
        return Math.abs(expense.reduce((total, transaction) => total + parseInt(transaction.amount), 0));
    };
    

    // Menghitung sisa anggaran
    
    getTotalBalance = () => {
        return this.getTotalIncome() - this.getTotalExpenses();
    };
    
    // Menghitung persentase penggunaan per kategori
    getUsagePercentage = (allocated, spent) => {
        return Math.min(100, (Math.abs(spent) / allocated) * 100);
    };

    // Menentukan variant progress bar berdasarkan persentase
    getProgressVariantExpenses = (percentage) => {
        if (percentage > 90) return 'danger';
        if (percentage > 75) return 'warning';
        return 'success';
    };
    getProgressVariantIncome = (percentage) => {
        if (percentage > 90) return 'success';
        if (percentage > 75) return 'warning';
        return 'danger';
    };

    // Filter anggaran berdasarkan status
    filterBudgets = () => {
        const { budgets, filter } = this.state;
        
        switch(filter) {
        case 'overbudget':
            return budgets.filter(budget => budget.spent > budget.allocated);
        case 'warning':
            return budgets.filter(budget => 
            budget.spent <= budget.allocated && 
            this.getUsagePercentage(budget.allocated, budget.spent) > 75
            );
        case 'safe':
            return budgets.filter(budget => 
            this.getUsagePercentage(budget.allocated, budget.spent) <= 75
            );
        default:
            return budgets;
        }
    };

    getSpent = (id) =>{
        let asset = this.props.transactions.filter(asset => (asset.category_id ===id))
        return asset.reduce((total, asset) => total + parseInt(asset.amount), 0)
    }

    ListCategory = () =>{
        //console.log(this.props.assets)
        try{
        var categories = this.props.categories
        var pemasukan, pengeluaran
        if(typeof categories == "object"){
        pemasukan = categories.filter(categori => (categori.type ==='1'))
        pengeluaran = categories.filter(categori => (categori.type ==='2'))
        }else{
            pemasukan = [];
            pengeluaran = []
        }

        const filteredBudgets = this.filterBudgets();
        const totalAllocatedIncome = this.getTotalAllocatedIncome();
        const totalAllocatedExpenses = this.getTotalAllocatedExpenses();
        const totalExpenses = this.getTotalExpenses();
        const totalIncome = this.getTotalIncome();
        const TotalBalance = this.getTotalBalance();
        const overallIncome = totalAllocatedIncome > 0 ? (totalIncome / totalAllocatedIncome) * 100 : 0;
        const overallExpenses = totalAllocatedExpenses > 0 ? (totalExpenses / totalAllocatedExpenses) * 100 : 0;

        //console.log(pengeluaran)
            
        //console.log(asetLancar)
        return (
            <Container>
                    
            
                    {/* Ringkasan Anggaran */}
                    <Row className="mb-4">
                      <Col md={4} className="mb-3">
                        <Card className="h-100 border-0 shadow-sm">
                          <Card.Body className="text-center">
                            <h6 className="card-title text-muted">Total Pendapatan</h6>
                            <h3 className="text-primary">
                              Rp {totalIncome.toLocaleString('id-ID')}
                            </h3>
                          </Card.Body>
                        </Card>
                      </Col>
                      <Col md={4} className="mb-3">
                            <Card className="h-100 border-0 shadow-sm">
                            <Card.Body className="text-center">
                                <h6 className="card-title text-muted">Total Pengeluaran</h6>
                                <h3 className="text-danger">
                                Rp {totalExpenses.toLocaleString('id-ID')}
                                </h3>
                            </Card.Body>
                            </Card>
                        </Col>
                        <Col md={4} className="mb-3">
                            <Card className="h-100 border-0 shadow-sm">
                                <Card.Body className="text-center">
                                <h6 className="card-title text-muted">Saldo</h6>
                                <h3 className={TotalBalance >= 0 ? 'text-success' : 'text-danger'}>
                                    Rp {Math.abs(TotalBalance).toLocaleString('id-ID')}
                                    {TotalBalance < 0 && ' (Defisit)'}
                                </h3>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>

                    
            
                    <Row>
                        <Col md={6}>
                            <Card className="border-0 shadow-sm">
                                <Card.Header>
                                    <h5 className="m-0">
                                        <i className="fas fa-wallet me-2 text-success"></i>
                                        Pendapatan
                                    </h5>
                                </Card.Header>
                                {/* Progress Bar Overall */}
                                <Card className="mb-4 border-0 shadow-sm">
                                    <Card.Body>
                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                        <h6 className="mb-0">Penggunaan Anggaran Keseluruhan</h6>
                                        <Badge bg={this.getProgressVariantIncome(overallIncome)}>
                                        {overallIncome.toFixed(1)}%
                                        </Badge>
                                    </div>
                                    <ProgressBar 
                                        now={overallIncome} 
                                        variant={this.getProgressVariantIncome(overallIncome)} 
                                        className="mb-3"
                                    />
                                    <div className="d-flex justify-content-between">
                                        <small className="text-muted">
                                        Realisasi: Rp {totalIncome.toLocaleString('id-ID')}
                                        </small>
                                        <small className="text-muted">
                                        Total: Rp {totalAllocatedIncome.toLocaleString('id-ID')}
                                        </small>
                                    </div>
                                    </Card.Body>
                                </Card>
                                <Card.Body className="p-0">
                                    <Table responsive hover className="mb-0">
                                    <thead className="table-light">
                                        <tr>
                                        <th>Kategori</th>
                                        <th>Dialokasikan</th>
                                        <th>Realisasi</th>
                                        <th>Progress</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {pemasukan.map((item) => (
                                        <tr key={item.id} onClick={() => this.editData(item)}>
                                            <td>
                                                <div className="d-flex align-items-center">
                                                <span 
                                                    className="me-2" 
                                                >
                                                </span>
                                                {item.desc}
                                                </div>
                                            </td>
                                            <td>Rp {parseInt(item.budget).toLocaleString('id-ID')}</td>
                                            <td>Rp {this.getSpent(item.id).toLocaleString('id-ID')}</td>
                                            
                                            <td>
                                                <div className="d-flex align-items-center">
                                                <ProgressBar 
                                                    now={this.getUsagePercentage(item.budget, this.getSpent(item.id))} 
                                                    variant={this.getProgressVariantIncome(this.getUsagePercentage(item.budget, this.getSpent(item.id)))} 
                                                    style={{ width: '80%', height: '8px' }} 
                                                    className="me-2"
                                                />
                                                <small>{this.getUsagePercentage(item.budget, this.getSpent(item.id)).toFixed(0)}%</small>
                                                </div>
                                            </td>
                                        </tr>
                                        ))}
                                    </tbody>
                                    </Table>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col md={6}>
                            <Card className="border-0 shadow-sm">
                                <Card.Header>
                                    <h5 className="m-0">
                                        <i className="fas fa-wallet me-2 text-success"></i>
                                        Pengeluaran
                                    </h5>
                                </Card.Header>
                                <Card className="mb-4 border-0 shadow-sm">
                                    <Card.Body>
                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                        <h6 className="mb-0">Penggunaan Anggaran Keseluruhan</h6>
                                        <Badge bg={this.getProgressVariantExpenses(overallExpenses)}>
                                        {overallExpenses.toFixed(1)}%
                                        </Badge>
                                    </div>
                                    <ProgressBar 
                                        now={overallExpenses} 
                                        variant={this.getProgressVariantExpenses(overallExpenses)} 
                                        className="mb-3"
                                    />
                                    <div className="d-flex justify-content-between">
                                        <small className="text-muted">
                                        Realisasi: Rp {totalExpenses.toLocaleString('id-ID')}
                                        </small>
                                        <small className="text-muted">
                                        Total: Rp {totalAllocatedExpenses.toLocaleString('id-ID')}
                                        </small>
                                    </div>
                                    </Card.Body>
                                </Card>
                                <Card.Body className="p-0">
                                    <Table responsive hover className="mb-0">
                                    <thead className="table-light">
                                        <tr>
                                        <th>Kategori</th>
                                        <th>Dialokasikan</th>
                                        <th>Terpakai</th>
                                        <th>Progress</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {pengeluaran.map((item) => (
                                        <tr key={item.id } onClick={() => this.editData(item)}>
                                            <td>
                                                <div className="d-flex align-items-center">
                                                <span 
                                                    className="me-2" 
                                                >
                                                </span>
                                                {item.desc}
                                                </div>
                                            </td>
                                            <td>Rp {parseInt(item.budget).toLocaleString('id-ID')}</td>
                                            <td>Rp {Math.abs(this.getSpent(item.id)).toLocaleString('id-ID')}</td>
                                            
                                            <td>
                                                <div className="d-flex align-items-center">
                                                <ProgressBar 
                                                    now={this.getUsagePercentage(item.budget, this.getSpent(item.id))} 
                                                    variant={this.getProgressVariantExpenses(this.getUsagePercentage(item.budget, this.getSpent(item.id)))} 
                                                    style={{ width: '80%', height: '8px' }} 
                                                    className="me-2"
                                                />
                                                <small>{this.getUsagePercentage(item.budget, Math.abs(this.getSpent(item.id))).toFixed(0)}%</small>
                                                </div>
                                            </td>
                                        </tr>
                                        ))}
                                    </tbody>
                                    </Table>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                    



                    




                </Container>
            
        );
            }
            catch(e){
                console.log(e)
            }
    }

    CreateCategoryModal = (data) =>{
        return(
        <Modal size="lg" contentClassName="form" show={this.state.show} onHide={this.handleClose}>
        <Modal.Body>
            <CreateCategoryForm handleClose={this.handleClose} show={this.state.show} data={this.state.data} update={this.state.update} action={this.props.setCategory}/>
        </Modal.Body>
      </Modal>
        )
    }

    editData =(data)=>{
        //console.log(data)
        this.setState({data:data, update:true})
        this.handleShow()
    }

    

    render(){
        return (
            <>
                <this.CreateCategoryModal/>
                <Container className="my-5">
                    <Row className="mb-4 sub-title">
                      <Col>
                        <h2 className="d-flex align-items-center">
                          <FaChartPie className="me-2 text-primary" />
                          Kategori & Anggaran
                        </h2>
                        <p className="text-muted d-none d-sm-block">Kelola anggaran bulanan Anda dengan mudah</p>
                      </Col>
                      <Col xs="auto">
                        <Button variant="primary" className="modal-trigger-btn" onClick={this.handleShow}>
                          <FaPlus className="me-1" /> Kategori
                        </Button>
                      </Col>
                    </Row>
                    
                    <Row>
                        <Col>
                        <this.ListCategory/>
                        
                        
                        </Col>
                    </Row>
                </Container>
            </>
                
        );
    }
}

const mapStateToProps = state => {
    return{
        categories: state.categories,
        transactions: state.transactions
    }
}

const mapDispatchToProps = dispatch => {
    return{
        getCategories: (book) => dispatch(getCategories(book)),
        setCategory: (book) => dispatch(setCategory(book)),
    }
} 
export default connect(mapStateToProps, mapDispatchToProps)(Category);

